import { render, staticRenderFns } from "./AccountProfileSettingsEditAddress.vue?vue&type=template&id=b5a15d04&"
import script from "./AccountProfileSettingsEditAddress.vue?vue&type=script&lang=js&"
export * from "./AccountProfileSettingsEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports